#include <colorspace_fragment>

if(!gl_FrontFacing)
    gl_FragColor = vec4(0.75, 0.15, 0.3, 1.0);